export default createContext({
  showCommentFieldTrigger: true
})
